// extracted by mini-css-extract-plugin
export default {"root":"r8Jbdj","checkbox":"K9zDRB","checkboxError":"A8cLZj"};